import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/TopDestinations/components/Container.js';
import { Content } from '../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/TopDestinations/components/Content.js';
import { Item } from '../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/TopDestinations/components/Item/index.js';
import { LabelMediumBold } from '../../../../../../../primitives/index.js';
import { qaId } from '../../../../../../../utils/index.js';
import { SEARCH_FORM_QA_ID } from '../../../../../../../utils/qaId.js';
export const TopDestinations = ({
  item,
  onSelectKeyword
}) => {
  return _jsxs(Container, {
    children: [item.headline && _jsx(LabelMediumBold, {
      as: item.headline.tag,
      children: item.headline.text
    }), _jsx(Content, {
      children: item.links?.map((link, index) => _jsx(Item, {
        "data-testid": qaId(SEARCH_FORM_QA_ID, 'destinationLayer', `topDestination${index + 1}`),
        item: link,
        onSelectKeyword: onSelectKeyword
      }, index))
    })]
  });
};